import {
    getAverageIdleDaysRangeValues,
    getAverageLactationDaysValues,
    getAverageParturitionWeightRangeValues,
    getAverageSeparationWeightRangeValues,
    getHealthyPigletsPerLitterRangeValues,
    getParturitionIndexRangeValues,
    getPigletMortality,
    getSeparatedPigletsPerLitterRangeValues,
} from "../utils/SettingsUtils";

const animalIndex =
    "SELECT value as val FROM ParamsTable WHERE AnmID = ? AND key = 'index'";
const averageLiveBorn =
    "SELECT AVG(value::INTEGER) as val FROM ParamsTable WHERE AnmID = ? AND key = 'liveBornPiglet'";
const averageBornWeight =
    "SELECT MAX(average) AS val FROM ( SELECT SUM(piglets * weight) / SUM(piglets) AS average FROM ( SELECT AnmID, MAX_BY(value, cycle) FILTER (WHERE key = 'bornPiglet')::INTEGER AS piglets, MAX_BY(value, cycle) FILTER (WHERE key = 'bornPigletWeight')::INTEGER AS weight FROM ParamsTable WHERE key IN ('bornPiglet', 'bornPigletWeight') AND AnmID = ? GROUP BY AnmID ) GROUP BY AnmID )";
const averageWeanedPiglets =
    "SELECT AVG(value::INTEGER) as val FROM ParamsTable WHERE AnmID = ? AND key = 'weanedPiglet'";
const averageWeanedWeight =
    "SELECT SUM(s1.piglets * s2.weight) / SUM(s1.piglets) as val FROM (SELECT EvID, value::INTEGER as piglets FROM ParamsTable WHERE AnmID = ? AND key = 'weanedPiglet') as s1 INNER JOIN (SELECT EvID, value::INTEGER as weight FROM ParamsTable WHERE AnmID = ? AND key = 'weanedPigletWeight') as s2 ON s1.EvID = s2.EvID";
const averageIdleDays =
    "SELECT AVG(value::INTEGER) as val FROM ParamsTable WHERE AnmID = ? AND key = 'idleDays'";
const averageLactationDays =
    "SELECT AVG(value::INTEGER) as val FROM ParamsTable WHERE AnmID = ? AND key = 'lactationDays'";
const pigletMortality =
    "SELECT AVG(dead * 100.0 / live) AS val FROM ( SELECT cycle, IFNULL(SUM(CASE WHEN key = 'deadPiglet' THEN value::INTEGER END)::INTEGER, 0) AS dead, IFNULL(MAX_BY(value::INTEGER, cycle) FILTER (WHERE key = 'liveBornPiglet'), 0) AS live FROM ParamsTable WHERE AnmID = ? AND key IN ('deadPiglet', 'liveBornPiglet') GROUP BY cycle )";

const animalIndexMax =
    "SELECT MAX(value::INTEGER) as val FROM ParamsTable WHERE key = 'index' AND value IS NOT NULL AND value <> 'null' AND value <> 'Infinity'";
const averageLiveBornMax =
    "SELECT MAX(averageBorn) as val FROM (SELECT AVG(value::INTEGER) as averageBorn FROM ParamsTable WHERE key = 'liveBornPiglet' GROUP BY AnmID)";
const averageBornWeightMax =
    "SELECT MAX(average) AS val FROM ( SELECT SUM(piglets * weight) / SUM(piglets) AS average FROM ( SELECT AnmID, MAX_BY(value::INTEGER, cycle) FILTER (WHERE key = 'bornPiglet') AS piglets, MAX_BY(value::INTEGER, cycle) FILTER (WHERE key = 'bornPigletWeight') AS weight FROM ParamsTable WHERE key IN ('bornPiglet', 'bornPigletWeight') GROUP BY AnmID, cycle ) GROUP BY AnmID )";
const averageWeanedPigletsMax =
    "SELECT MAX(average) as val FROM (SELECT AVG(value::INTEGER) as average FROM ParamsTable WHERE key = 'weanedPiglet' GROUP BY AnmID)";
const averageWeanedWeightMax =
    "SELECT MAX(weight) as val FROM ( SELECT WEIGHTED_AVG(s2.weight, s1.piglets) as weight FROM ( SELECT AnmID, EvID, value::INTEGER as piglets FROM ParamsTable WHERE key = 'weanedPiglet' ) as s1 INNER JOIN ( SELECT AnmID, EvID, value::INTEGER as weight FROM ParamsTable WHERE key = 'weanedPigletWeight' ) as s2 ON s1.EvID = s2.EvID GROUP BY s1.AnmID )";
const averageIdleDaysMax =
    "SELECT MAX(average) as val FROM (SELECT AVG(value::INTEGER) as average FROM ParamsTable WHERE key = 'idleDays' GROUP BY AnmID)";
const averageLactationDaysMax =
    "SELECT MAX(average) as val FROM (SELECT AVG(value::INTEGER) as average FROM ParamsTable WHERE key = 'lactationDays' GROUP BY AnmID)";

const liveBornInfo =
    "SELECT cycle::INTEGER as cycle, LAST(group_nr) as group, SUM(CASE WHEN key = 'liveBornPiglet' THEN value::INTEGER END) as born, SUM(CASE WHEN key = 'deadBornPiglet' THEN value::INTEGER END) as dead, SUM(CASE WHEN key = 'mummyBornPiglet' THEN value::INTEGER END) as mummy, SUM(CASE WHEN key = 'giltsBornPiglet' THEN value::INTEGER END) as gilts, SUM(CASE WHEN key = 'weakBornPiglet' THEN value::INTEGER END) as weak FROM ParamsTable WHERE AnmID = ? AND key in ('liveBornPiglet', 'deadBornPiglet', 'mummyBornPiglet', 'weakBornPiglet', 'giltsBornPiglet') GROUP BY cycle ORDER BY cycle";
const bornWeightInfo =
    "SELECT cycle::INTEGER as cycle, LAST(group_nr) as group, SUM(CASE WHEN key = 'liveBornPiglet' THEN value::INTEGER END) as born, SUM(CASE WHEN key = 'bornPigletWeight' THEN value::INTEGER END) as weight FROM ParamsTable WHERE AnmID = ? AND key IN ('liveBornPiglet', 'bornPigletWeight') GROUP BY cycle ORDER BY cycle";
const weanedPigletsInfo =
    "SELECT cycle::INTEGER as cycle, LAST(group_nr) as group, SUM(CASE WHEN key = 'weanedPiglet' THEN value::INTEGER END) as weaned, SUM(CASE WHEN key = 'liveBornPiglet' THEN value::INTEGER END) as born, SUM(CASE WHEN key = 'deadPiglet' THEN value::INTEGER END) as fall, SUM(CASE WHEN key = 'fostering' THEN value::INTEGER END) as fostering FROM ParamsTable WHERE AnmID = ? AND key IN ('weanedPiglet', 'liveBornPiglet', 'deadPiglet', 'fostering') GROUP BY cycle ORDER BY cycle";
const weanedWeightInfo =
    "SELECT * FROM ( SELECT TRY_CAST(cycle AS INTEGER) AS cycle, LAST(group_nr) as group, SUM(CASE WHEN key = 'weanedPigletWeight' THEN TRY_CAST(value AS INTEGER) END) AS weight, SUM(CASE WHEN key = 'weanedPiglet' THEN TRY_CAST(value AS INTEGER) END) AS weaned, MAX_BY(TRY_CAST(value AS INTEGER), cycle) FILTER (WHERE key = 'activeNipples') AS active FROM ParamsTable WHERE AnmID = ? AND key IN ('weanedPigletWeight', 'weanedPiglet', 'activeNipples') GROUP BY cycle ) ORDER BY cycle";
const idleDaysInfo =
    "SELECT FIRST(cycle)::INTEGER as cycle, LAST(group_nr) as group, SUM(CASE WHEN key = 'idleDays' THEN value::INTEGER END) as idle FROM ParamsTable WHERE AnmID = ? AND key = 'idleDays' GROUP BY cycleIndex ORDER BY cycle";
const lactationDaysInfo =
    "SELECT cycle::INTEGER as cycle, LAST(group_nr) as group, SUM(CASE WHEN key = 'lactationDays' THEN value::INTEGER END) as lactation, SUM(CASE WHEN key = 'lactationMommyDays' THEN value::INTEGER END) as mommy FROM ParamsTable WHERE AnmID = ? AND key IN ('lactationDays', 'lactationMommyDays') GROUP BY cycle ORDER BY cycle";
const pigletMortalityInfo =
    "SELECT cycle::INTEGER as cycle, LAST(group_nr) as group, SUM(CASE WHEN key = 'liveBornPiglet' THEN value::INTEGER END) as born, SUM(CASE WHEN key = 'deadPiglet' THEN value::INTEGER END) as dead FROM ParamsTable WHERE AnmID = ? AND key IN ('liveBornPiglet', 'deadPiglet') GROUP BY cycle ORDER BY cycle";
const indexInfo =
    "SELECT FIRST(cycle::INTEGER) as cycle, LAST(group_nr) as group, SUM(CASE WHEN key = 'idleDays' THEN value::INTEGER END) as idle, SUM(CASE WHEN key = 'gestationDays' THEN value::INTEGER END) as gestation, SUM(CASE WHEN key = 'lactationDays' THEN value::INTEGER END) as lactation, SUM(CASE WHEN key = 'gestationDays' OR key = 'lactationDays' THEN value::INTEGER END) as productive FROM ParamsTable WHERE AnmID = ? AND key IN ('idleDays', 'gestationDays', 'lactationDays') GROUP BY cycleIndex ORDER BY cycle";

const sowStatus =
    "SELECT value FROM ParamsTable WHERE AnmID = ? AND key = 'sowState'";

export const sowUtils = {
    sowStatus,
};

export const sowResultSelects = {
    animalIndex,
    averageLiveBorn,
    averageBornWeight,
    averageWeanedPiglets,
    averageWeanedWeight,
    averageIdleDays,
    averageLactationDays,
    pigletMortality,
};

export const sowResultsAutoRange = {
    animalIndex: animalIndexMax,
    averageLiveBorn: averageLiveBornMax,
    averageBornWeight: averageBornWeightMax,
    averageWeanedPiglets: averageWeanedPigletsMax,
    averageWeanedWeight: averageWeanedWeightMax,
    averageIdleDays: averageIdleDaysMax,
    averageLactationDays: averageLactationDaysMax,
};

export const sowResultsInfo = {
    liveBornInfo,
    bornWeightInfo,
    weanedPigletsInfo,
    weanedWeightInfo,
    idleDaysInfo,
    lactationDaysInfo,
    pigletMortalityInfo,
    indexInfo,
};

export const sowResultsMinMaxFunctions = {
    animalIndex: getParturitionIndexRangeValues,
    averageLiveBorn: getHealthyPigletsPerLitterRangeValues,
    averageBornWeight: getAverageParturitionWeightRangeValues,
    averageWeanedPiglets: getSeparatedPigletsPerLitterRangeValues,
    averageWeanedWeight: getAverageSeparationWeightRangeValues,
    averageIdleDays: getAverageIdleDaysRangeValues,
    averageLactationDays: getAverageLactationDaysValues,
    pigletMortality: getPigletMortality,
};
